export default __webpack_public_path__ + "static/media/fa-solid-900.422cfe28.ttf";